import React, { useState } from 'react'
import { COLOR_PRIMARY } from '../../../constants'
import { CheckCircleFilled } from '@ant-design/icons'
import { FormLabel } from '../../../components/form/FormLabel'

export const HORIZONTAL = 'horizontal'
export const VERTICAL = 'vertical'
export const BodyPartSelector = ({ bodyparts, setSelectedBodyPart, className = '', direction = HORIZONTAL }) => {
  const [selected, setSelected] = useState<number | null>(null)

  const onBodyPartSelect = (index) => {
    const item = bodyparts[index]
    setSelected(index)
    setSelectedBodyPart(item.bodyPart)
  }

  const items = bodyparts
  /*const items = [
    { label: 'Left Arm' },
    { label: 'Right Arm' },
    { label: 'Left Leg' },
    { label: 'Right Leg' },
    { label: 'Torso' },
  ]*/

  const layoutDirection = direction === HORIZONTAL ? 'flex-row' : 'flex-column'

  const deselectedColor = '#cccccc'

  return (
    <div className={className || 'row mt-3 mb-3'}>
      {items.length !== 0 ? (
        <>
          <div className="col-12 mb-1">
            <FormLabel label="Select target body part:"></FormLabel>
          </div>
        </>
      ) : (
        <></>
      )}

      <div className={'col-12  d-flex ' + layoutDirection + ' justify-content-between  '}>
        {items.map((option, index) => {
          const isSelected = selected === index

          return (
            <div
              key={index}
              onClick={() => {
                onBodyPartSelect(index)
              }}
              className="rounded-2 w-100 py-3 pointer mb-2"
              style={{
                marginRight: direction === HORIZONTAL && index !== items.length - 1 ? '1rem' : 0,
                zIndex: isSelected ? 2 : 0,
                background: isSelected ? '#FFFFFF' : '#FFFFFF',
                border: isSelected ? `2px solid ${COLOR_PRIMARY}` : `2px solid ${deselectedColor}`,
                boxShadow: isSelected ? '0px 3px 10px -2px rgba(0, 0, 0, 0.4)' : '0px 4px 8px -4px rgba(0, 0, 0, 0.15)',
              }}
            >
              <div className="position-relative d-flex align-items-center my-1">
                {isSelected ? (
                  <CheckCircleFilled className="ms-3 me-2" style={{ fontSize: 25, color: COLOR_PRIMARY }} />
                ) : (
                  <div
                    className="ms-3 me-2 rounded-circle  "
                    style={{ width: 25, height: 25, border: `2px solid ${deselectedColor}` }}
                  ></div>
                )}
                <h6 className="mb-1 mt-1 ps-1" style={{ opacity: isSelected ? 1 : 0.8 }}>
                  {option.label}
                </h6>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
